import React from "react";
import { Box, Typography } from "@mui/material";
import styles from "./DatePanel.module.css";
import GenericDateRange from "./DateRange";
import PresetToggleGroup from "./PresetToggleGroup";

export interface DatePanelProps {}

const DatePanel: React.FunctionComponent<DatePanelProps> = ({}) => {
  return (
    <Box className={styles.datePanelContainer}>
      <Box className={styles.row}>
        <Typography variant="h5" className={styles.title}>
          Period
        </Typography>
      </Box>
      <Box className={styles.row}>
        <GenericDateRange />
      </Box>
      <Box className={styles.row}>
        <PresetToggleGroup />
      </Box>
    </Box>
  );
};

export default DatePanel;
